import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import useDebounce from "../../hooks/useDebounce";
import useFullPageLoader from "../../hooks/useFullPageLoader";
import { Avatar, IconButton } from "@mui/material";
import Switch from "../../components/Switch/Switch";
import NotFound from "../../components/not-found/NotFound";
import Pagination from "react-js-pagination";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { category, explore, music } from "../../routes/route";
import common from "../../routes/common";
import { toastMessage } from "../../utils/toastMessage";
import findSerialNumber from "../../utils/findSerialNumber";
import { charLimit } from "../../utils/charLimit";
import { fetchMusicApi } from "../../services/musicManagement";
import EditIcon from "@mui/icons-material/Edit";
// import AddMusic from "./AddMusicCategory";
// import showFullSizeImage from "../../utils/showFullSizeImage";
// import MusicCategoryStatus from "./MusicCategoryStatus";
// import EditMusicCategory from "./EditMusicCategory";
import scrollToUp from "../../utils/scrollToUp";
import { getLocalStorage, setLocalStorage } from "../../config/config";
import ImagePreviewModel from "../../components/imagePreview/ImagePreviewModel";
import { fetchExploreApi, fetchUserExploreActivityApi } from "../../services/exploreManagement";
import ExploreStatus from "./ExploreStatus";
import AddStories from "./AddStories";
import EditStories from "./EditStories";
import AddIcon from "@mui/icons-material/Add";
import DescriptionModel from "../../components/imagePreview/DescriptionModel";
// import VideoThumbnail from 'react-video-thumbnail'
import { regex } from "../../utils/regex";
import VideoThumbnail from "../../comman/VideoThumbnails";
import videoLogo from "../../Assests/image/videoLogo.png";
import UserExploreInSights from "./UserExploreInSights";
const { NOT_FOUND } = common;
const { EXPLORE_DETAIL } = explore;

const UserExploreActivity = () => {
  // handle all state
  const [searchParam, setSearchParam] = useSearchParams();
  let activePage = +searchParam.get("page") || 1;
  // const [search, setSearch] = useState(searchParam.get('query') || '')
  const [search, setSearch] = useState(
    getLocalStorage("exploreList", "search") || ""
  );
  const debounceValue = useDebounce(search || "", 300);

  const [addModal, setAddModal] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [descriptionModel, setDescriptionModel] = useState(false);
  const [description, setDescription] = useState("");
  const [exploreList, setExploreList] = useState([]);
  const [total, setTotal] = useState(0);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [statusModal, setStatusModal] = useState(false);
  const [statusValue, setStatusValue] = useState("");
  const [statusId, setStatusId] = useState("");
  const [selectedExploreDetail, setSelectedExploreDetail] = useState(null);
  const [showImagePreviewModel, setShowImagePreviewModel] = useState(false);
  const [imagePreview, setImagePreview] = useState("");
  const [imageTitle, setImageTitle] = useState("");
  const { imageFileRegex, videoFileRegex } = regex;
  const [meditationVideo, setMeditationVideo] = useState({});

  // Function to set localStorage values whenever the state variables change
  useEffect(() => {
    setLocalStorage("userExploreActivity", "search", search);
  }, [search]);
  //*********Handel status********* */
 

  //*********Handel Block********* */
  // const blockHandler = (id, status) => {
  //     setBlockModal(true);
  //     setBlockId(id);
  //     // setStatusValue(status);
  // };
  //*********Handle update********* */
  // const updateHandler = (id, enName, arName, imageUrl, categoryId) => {
  //   setUpdateModal(true)
  //   setUpdateSubCategoryData({
  //     id,
  //     enName,
  //     arName,
  //     imageUrl,
  //     categoryId,
  //   })
  // }
  //*********Handel Pagination********* */
  const handlePageChange = (event) => {
    searchParam.set("page", event);
    setSearchParam(searchParam);
  };

  const showImagePreviewHandler = (explore) => {
    setShowImagePreviewModel(true);
    setImageTitle(explore.title);
    if (explore.media.type === "video") {
      setImagePreview(videoLogo);
    } else {
      setImagePreview(explore.media.url);
    }
  };


  // //------------------listing-music-Api----------------------------------
  const fetchUserExploreActivityHandler = async () => {
    try {
      setExploreList([]);
      showLoader();
      const sendData = {
        page: activePage,
        limit: 10,
      };
      if (debounceValue) {
        sendData.page = 1;
        sendData.search = debounceValue;
        searchParam.delete("page");
        setSearchParam(searchParam);
      }
      const { data } = await fetchUserExploreActivityApi(sendData);
      if (data.code === 200) {
        setExploreList(data?.result?.list || []);
        setTotal(data?.result?.total || 0);
        scrollToUp();
      } else {
        setExploreList([]);
        setTotal(0);
        toastMessage(data.message, "error", "exploreList");
      }
    } catch (error) {
      console.log("error", error);
    } finally {
      hideLoader();
    }
  };

  // useEffect(() => {
  //   if (debounceValue) {
  //     searchParam.set('query', debounceValue)
  //   } else {
  //     searchParam.delete('query')
  //   }
  //   if (activePage === 1) {
  //     searchParam.delete('page')
  //   }
  //   setSearchParam(searchParam)
  //   fetchCategoryHandler(activePage, debounceValue)
  // }, [searchParam, debounceValue])
  useEffect(() => {
    if (activePage === 1) {
      searchParam.delete("page");
    }
    setSearchParam(searchParam);
    fetchUserExploreActivityHandler();
  }, [searchParam, debounceValue]);
  return (
    <>
      {loader}
      <div className="WrapperArea">
        <div className="WrapperBox">
          <div className="TitleBox">
            <h4 className="Title">User Explore Activity</h4>
            
          </div>
          <UserExploreInSights />
          <div className="FilterBox FilterArea ">
            <div className="form-group search_lg_size userSearch">
              <input
                type="search"
                className="form-control"
                placeholder="Search"
                value={search || ""}
                style={{ "--color": "#FF8989" }}
                onChange={(e) => setSearch(e.target.value)}
              />
              <span className="user_search_icon">{common.SEARCH_ICON}</span>
            </div>
          </div>
          <div className="content-table">
            <table>
              <thead>

              {/* sNo: { $add: ['$sNo', 1] }, // 1-based indexing
            userName: '$records.userName',
            userId: '$records.userId',
            mailId: '$records.mailId',
            openingDateTime: '$records.openingDateTime',
            totalTimeSpent: '$records.totalTimeSpent',
            likes: '$records.likes',
            comments: '$records.comments', */}
                <tr>
                  <th>S. No.</th>
                  <th>User Name</th>
                  <th>User Id</th>
                  <th>Mail Id</th>
                  <th>Opening Date Time</th>
                  <th>Total Time Spent</th>
                  <th>Likes</th>
                  <th>Comments</th>
                </tr>
              </thead>

              <tbody>
                {exploreList.length > 0 ? (
                  exploreList.map((explore, index) => {
                    return (
                      <React.Fragment key={explore._id}>
                       <tr>
                        <td>{index + 1}</td>
                        <td>{explore.userName || '---'}</td>
                        <td>{explore.userId || '---'}</td>
                        <td>{explore.mailId || '---'}</td>
                        <td>{explore.openingDateTime || '---'}</td>
                        <td>{explore.totalTimeSpent}</td>
                        <td>{explore.likes}</td>
                        <td>{explore.comments}</td>
                       </tr>
                      </React.Fragment>
                    );
                  })
                ) : (
                  <NotFound
                    cols={7}
                    msg="Explore not found!"
                    icon={NOT_FOUND}
                    loader={loader}
                  />
                )}
              </tbody>
            </table>
          </div>
          {total >= 10 ? (
            <div className="pagination-wrapper">
              <div className="Pagination">
                <Pagination
                  activePage={activePage}
                  previousLabel={"previous"}
                  nextLabel={"next"}
                  itemsCountPerPage={10}
                  totalItemsCount={total}
                  pageRangeDisplayed={10}
                  onChange={handlePageChange}
                  hideDisabled={true}
                />
              </div>
            </div>
          ) : null}
        </div>
       
      </div>
    </>
  );
};

export default UserExploreActivity;
